import React, { useContext } from 'react';
import { AppContext } from '../AppContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import Typography from "@material-ui/core/Typography";




export default function FullScreenLoading(props) {

    const useStyles = makeStyles((theme) => ({
        root: {
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100vh",
            background: theme.palette.background.image,
            backgroundSize: "cover",
            padding: theme.spacing(2),
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            color: "white"
        },
    }));

    const classes = useStyles(props);

    if (props.visible) {
        return (
            <div className={classes.root}>
                <CircularProgress color="inherit" />
                <p style={{ color: "#cccccc" }}>{props.text}</p>
            </div>
        );
    }
    return null;
}

